import { render, staticRenderFns } from "./ComButton.vue?vue&type=template&id=b3525ef4&scoped=true"
import script from "./ComButton.vue?vue&type=script&lang=js"
export * from "./ComButton.vue?vue&type=script&lang=js"
import style0 from "./ComButton.vue?vue&type=style&index=0&id=b3525ef4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3525ef4",
  null
  
)

export default component.exports